export enum LocalStorage {
  GameConfig = 'gameConfig',
  UserDataAccessToken = 'userDataAccessToken',
  UserDataRefreshToken = 'userDataRefreshToken',
  GameStatus = 'GameStatus',
  CurrentTask = 'CurrentTask',
  RemovedPosts = 'RemovedPosts',
  PlayersPoints = 'PlayersPoints',
}
